import TopLogoComponent from '../../assets/1x/Mesa de trabajo 1.png';

export const Logo = () => {
  return (
    <div className="snn-top-menu-logo-wrapper">
      <img
        src={TopLogoComponent}
        alt="Symposium of Nanoscience and Nanotechnology Logo"
        className="snn-top-menu-logo"
      />
    </div>
  );
};
